import type { Page } from 'puppeteer';

import languages from './languages';

export const CLASSNAME_HAMBURGER_MENU_TOGGLE = 'mobile-header-hamburger-button';
export const CLASSNAME_LANGUAGE_PICKER = 'language-picker';
export const CLASSNAME_LANGUAGE_SELECT_MODAL = 'language-select-modal';

const SELECTOR_LANGUAGE_SELECT_MODAL = `.${CLASSNAME_LANGUAGE_SELECT_MODAL}`;
const SELECTOR_HAMBURGER_MENU_TOGGLE = `.${CLASSNAME_HAMBURGER_MENU_TOGGLE}`;
const SELECTOR_LANGUAGE_PICKER_TOGGLE = `.${CLASSNAME_LANGUAGE_PICKER}`;
const SELECTOR_TESTIMONIAL = '.keen-slider';
const SELECTOR_FOOTER = 'footer';

const languagesArr = Object.keys(languages);

const config = {
  // Login
  '/': {
    locales: languagesArr,
    actions: async (page: Page) => {
      // defered bundle
      await Promise.all([
        page.waitForSelector(SELECTOR_HAMBURGER_MENU_TOGGLE),
        page.waitForSelector(SELECTOR_TESTIMONIAL),
        page.waitForSelector(SELECTOR_FOOTER),
      ]);

      await page.tap(SELECTOR_HAMBURGER_MENU_TOGGLE);
      await page.waitForSelector(SELECTOR_LANGUAGE_PICKER_TOGGLE);

      // Puppeteer's page.tap() fn doesn't work when element is visually hidden,
      // evaluating native JS click fn instead (works with mobile menu hidden)
      await page.evaluate(
        (selector) => document.querySelector(selector).click(),
        SELECTOR_LANGUAGE_PICKER_TOGGLE
      );

      await page.waitForSelector(SELECTOR_LANGUAGE_SELECT_MODAL);
    },
  },
};

export default config;
